/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ComputeChangeToBalancesRequest} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/compute_change_to_balances.pb'
import {ComputeChangeToBalancesResponse} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/compute_change_to_balances.pb'


export const computeChangeToBalances = (request: ComputeChangeToBalancesRequest, options?: CashRequestOptions) => post<ComputeChangeToBalancesRequest, ComputeChangeToBalancesResponse>("/2.0/cash/compute-change-to-balances", request, {...options, rejectOnError: true })